export default __webpack_public_path__ + "static/media/closeIcon.1d83f222.svg";